import { useOutletContext } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Container, Reveal, Eyebrow, SectionHeading, PageBanner } from "@/site/ui";
import CallbackForm from "@/site/CallbackForm";

export default function Contact() {
  const c = useOutletContext();
  const ct = c.contact;
  const items = [
    { icon: Phone, label: "Call Us", value: c.footer.phone, href: `tel:${c.footer.phone.replace(/\s+/g, "")}` },
    { icon: Mail, label: "Mail Us", value: ct.email, href: `mailto:${ct.email}` },
    { icon: MapPin, label: "Visit Us", value: ct.address },
  ];
  return (
    <div data-testid="contact-page">
      <PageBanner image={c.banners?.contact} eyebrow="Contact Us" title="We're here to help you live better" subtitle={ct.company} />

      <section className="pt-16 md:pt-20 pb-16">
        <Container className="grid md:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div data-testid={`contact-${it.label.replace(/\s+/g, "-").toLowerCase()}`} className="h-full rounded-2xl border border-gray-100 bg-white p-8 shadow-sm">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[rgb(var(--rgh-primary-rgb)/0.08)] text-[var(--rgh-primary)]"><it.icon size={22} /></span>
                <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#525252]">{it.label}</p>
                {it.href ? <a href={it.href} className="mt-1 block text-base font-medium hover:text-[var(--rgh-primary)] transition-colors duration-200">{it.value}</a>
                  : <p className="mt-1 text-base font-medium leading-relaxed">{it.value}</p>}
              </div>
            </Reveal>
          ))}
        </Container>
      </section>

      <section className="pb-16">
        <Container>
          <Reveal>
            <div className="overflow-hidden rounded-[28px] border border-gray-100 shadow-sm">
              <iframe title="Raphadon location" data-testid="contact-map" src={ct.map_embed} width="100%" height="440" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </Reveal>
        </Container>
      </section>

      <section id="callback" className="py-16 md:py-24 bg-[#FAFAFA] scroll-mt-24">
        <Container>
          <Reveal><SectionHeading eyebrow="Want a callback?" title="Leave your details" sub="Our team will reach out to you shortly." /></Reveal>
          <div className="mt-8"><CallbackForm /></div>
        </Container>
      </section>
    </div>
  );
}
